<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>{{ $t('LISTS.ITEMS') }}</v-toolbar-title>

      <v-spacer />

      <v-btn dark color="indigo" @click="create()">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('LISTS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="pa-5" tile>
      <documents-lists-list-filter :value="filters" @setRequest="setFilters" />

      <documents-lists-list
        :meta="meta"
        :documents-lists="documentsLists"
        :options.sync="options"
        @show="show"
      />
    </v-sheet>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      max-width="600"
    >
      <component
        :is="component.name"
        :data="component.data"
        @created="cancelDialogAndRefresh"
        @updated="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import DocumentsListsList from '../components/DocumentsListsList.vue';
import DocumentsListsListFilter from '../components/DocumentsListsListFilter.vue';
import DataOptions from '@/modules/_global/classes/DataOptions';
import { DocumentsListsService } from '@/services/documents-lists.service';
import { debounce } from 'lodash';

const DEBOUNCE_DELAY = 300;

export default {
  name: 'DocumentsListsPage',

  components: {
    DocumentsListsList,
    DocumentsListsListFilter
  },

  data() {
    return {
      meta: {},
      documentsLists: [],
      filters: {},
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      dialog: false,
      component: null
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    params() {
      return Object.assign({}, this.filters, this.preparedOptions);
    }
  },

  watch: {
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.refreshData();
      }
    },
    filters: {
      deep: true,
      handler() {
        this.options.page = 1;
        this.refreshData();
      }
    }
  },

  methods: {
    refreshData: debounce(function debouncedGetDocumentsLists() {
      DocumentsListsService.getList(this.params).then(({ data }) => {
        this.documentsLists = data.data;
        this.meta = data.meta;
      });
    }, DEBOUNCE_DELAY),

    setFilters(filters) {
      this.filters = filters;
    },

    create() {
      this.$router.push({
        name: 'documents-lists.create'
      });
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    },
    show(item) {
      this.$router.push({
        name: 'documents-lists.show',
        params: { id: item.id }
      });
    }
  }
};
</script>

<style scoped></style>
